import { ObjectType, PatternType } from "../../../../contexts/types/card";
import ElaboratorsAndInstitutions from "../../shared/ElaboratorsAndInstitutions/elaboratorsAndInstitutions";
import CardCompletionDate from "../components/cardCompletionDate";
import Characteristics from "../components/characteristics";
import ColluvialMaterial from "../components/colluvialMaterial";
import ConductingObservation from "../components/conductingObservation";
import DeterminationDate from "../components/determinationDate";
import GenesisAndAge from "../components/genesisAndAge";
import GeologicalCrossSection from "../components/geologicalCrossSection";
import LandUse from "../components/landUse";
import Location from "../components/location";
import MapSection from "../components/map";
import MorfologicalParameters from "../components/morfologicalParameters";
import PhotographicDocumentation from "../components/photographicDocumentation";
import ResearchState from "../components/reasearchState";
import RegistrationNumber from "../components/registrationNumber";
import SecurityOptions from "../components/securityOptions";
import { FormContextProps } from "../components/shared/types/formContextProps";
import { FormSectionProps } from "../components/shared/types/formSectionProps";
import Subsoil from "../components/subsoil";
import ThreatsAndDamage from "../components/threatsAndDamage";
import WaterManifestation from "../components/waterManifestation";
import WorkPerformed from "../components/workPerformed";

const KrFormLandslide = (props: FormContextProps) => {
    const objectType = ObjectType.KRO;
    const version = props.context.landslideAttributes?.wersja;
    const is2007 = version === PatternType.P2007;
    const elaboratorsSectionTitle = (
        <>
            {is2007 ? <h2>18. Autor karty</h2> : <h2>18. Wypełniający kartę</h2>}
            {is2007 ? <h2>19. Kategoria i numer uprawnień geologicznych</h2> : <h2>19. Kategoria i numer kwalifikacji geologicznych wypełniającego kartę</h2>}
            {is2007 ? <h2>20. Instytucja</h2> : <h2>20. Instytucja reprezentowana przez wypełniającego kartę</h2>}
        </>
    );

    var formSectionProps: FormSectionProps = {
        editMode: props.editMode,
        objectType: objectType,
        version: version,
        getMapForNavScroll: props.getMapForNavScroll,
        getMapForComment: props.getMapForComment,
        setNewCommentFieldDetails: props.setNewCommentFieldDetails,
        setCommentsFilter: props.setCommentsFilter,
        markedFieldForCommentFiltering: props.markedFieldForCommentFiltering,
    }

    return (<>
        <div className="krFormSection-grid"><RegistrationNumber {...formSectionProps}/></div>
        <div className="krFormSection-flex"><Location {...formSectionProps}/></div>
        <div className="krFormSection-flex"><Characteristics {...formSectionProps}/></div>
        <div className="krFormSection-flex"><MorfologicalParameters {...formSectionProps}/></div>
        <div className="krFormSection-flex"><Subsoil {...formSectionProps}/></div>
        <div className="krFormSection-grid"><ColluvialMaterial {...formSectionProps}/></div>
        <div className="krFormSection-flex"><WaterManifestation {...formSectionProps}/></div>
        <div className="genesisAndAge"><GenesisAndAge {...formSectionProps}/></div>
        <div className="krFormSection-flex"><LandUse {...formSectionProps}/></div>
        <div className="krFormSection-flex"><ThreatsAndDamage {...formSectionProps}/></div>
        <div className="krFormSection-flex"><WorkPerformed {...formSectionProps}/></div>
        <div className="krFormSection-flex"><ConductingObservation {...formSectionProps} is2007={is2007}/></div>
        <div className="krFormSection-flex researchState"><ResearchState {...formSectionProps}/></div>
        <div className="krFormSection-flex"><MapSection {...formSectionProps} isLandslide={true}/></div>
        <div className="krFormSection-flex"><GeologicalCrossSection {...formSectionProps} isLandslide={true}/></div>
        <div className="krFormSection-flex"><PhotographicDocumentation {...formSectionProps} isLandslide={true} additionalDesc={true}/></div>
        <div className="krFormSection-flex"><SecurityOptions {...formSectionProps}/></div>
        <div className="krFormSection-flex"><ElaboratorsAndInstitutions {...formSectionProps} sectionTitle={elaboratorsSectionTitle} context={props.context} setContext={props.setContext} isKR={true}/></div>
        {!is2007 && <div className="krFormSection-flex"><DeterminationDate {...formSectionProps}/></div>}
        <div className="krFormSection-flex"><CardCompletionDate {...formSectionProps}/></div>
    </>)
}
export default KrFormLandslide;